<template>
	<div class="col-lg-8 col-sm-12">
		<div class="mapWrapper panel">
			<div class="panel-container">
				<div class="panel-content">
					<l-map
						class="map_container"
						:zoom="zoom"
						:center="center"
						:maxZoom="16"
						ref="Map"
						:fadeAnimation="true"
						:zoomControl="true"
						:zoomAnimation="true"
						:markerZoomAnimation="true"
						:noBlockingAnimations="true"
					>
						<l-tile-layer
							v-for="tileProvider in tileProviders"
							:key="tileProvider.name"
							:name="tileProvider.name"
							:visible="tileProvider.visible"
							:url="tileProvider.url"
							:attribution="tileProvider.attribution"
							layer-type="base"
						/>
						<l-control-scale position="bottomright" :imperial="false" :metric="true"></l-control-scale>

						<l-marker
							v-for="marker in Mapdata"
							:lat-lng="getMarkerCoordinates(marker.geometry.coordinates)"
							:key="marker.id"
							ref="marker.id"
							:name="marker.id"
							@click="selectItem(marker.id)"
						>
							<l-icon>
								<!-- <svg
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									:x="getMarkerSize(marker.properties.markerSize)"
									:y="getMarkerSize(marker.properties.markerSize)"
									width="40px"
									height="40px"
									:fill="marker.properties.Color"
									stroke="#000000"
									fill-opacity="0.7"
								>
									<polygon
										points="20.112,4.19 25.25,14.599 36.737,16.268 28.426,24.371 30.386,35.811 20.112,30.41 9.839,35.811 
	11.8,24.371 3.489,16.268 14.977,14.599 "
									/>
								</svg> -->

								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									width="25px"
									height="25px"
									viewBox="0 0 131.019 116.428"
								>
									<polygon
										:fill="marker.properties.Color"
										stroke="#000000"
										stroke-miterlimit="10"
										points="65.398,10 93.098,57.977 120.797,105.953 65.398,105.953
10,105.953 37.699,57.977 "
									/>
								</svg>
							</l-icon>
							<l-popup>
								<table class="table-striped balloon">
									<tbody>
										<tr>
											<td class="text-bold">{{ lang.code }}</td>
											<td>
												: <span v-html="marker.Kodi"></span>
												<span class="text-bold">
													{{ marker.properties.Kodi }}
												</span>
											</td>
										</tr>
										<tr>
											<td>{{ lang.latitude }} [°N]</td>
											<td>
												: <span v-html="marker.Latitude"></span>
												{{ marker.properties.Latitude }}
											</td>
										</tr>
										<tr>
											<td>{{ lang.longtitude }} [°E]</td>
											<td>
												: <span v-html="marker.Longitude"></span>
												{{ marker.properties.Longitude }}
											</td>
										</tr>
										<tr>
											<td>{{ lang.elevation }} [m]</td>
											<td>
												: <span v-html="marker.Elevation"></span>
												{{ marker.properties.Elevation }}
											</td>
										</tr>
										<tr>
											<td>{{ lang.city }}</td>
											<td>
												: <span v-html="marker.Qyteti"></span>
												{{ marker.properties.Qyteti }}
											</td>
										</tr>
										<tr>
											<td>{{ lang.sensor }}</td>
											<td>
												: <span v-html="marker.Sensor"></span>
												{{ marker.properties.Sensor }}
											</td>
										</tr>
									</tbody>
								</table>
							</l-popup>
						</l-marker>
					</l-map>
					<LegjendaMap :class="{ show: this.showLegend, hide: !this.showLegend }" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import LegjendaMap from './legjendajson.vue';
import { LMap, LIcon, LTileLayer, LMarker, LPopup, LControlScale } from '@vue-leaflet/vue-leaflet';
import timeAgo from '../utils/timeFormater.js';

export default {
	name: 'GeoMap',
	components: {
		LMap,

		LTileLayer,
		LMarker,
		LIcon,

		LPopup,
		LControlScale,
		LegjendaMap
	},
	data() {
		return {
			zoom: 8,
			center: [40.79717741518766, 20.181884765625],
			size: null,
			bounds: null,
			sizes: {
				small: '5',
				medium: '8',
				large: '12'
			},
			tileProviders: [
				{
					name: 'OpenStreetMap',
					visible: true,
					maxZoom: 19,

					url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
					attribution:
						'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				}
			]
		};
	},
	computed: {
		Mapdata() {
			return this.$parent.Mapdata;
		},
		selected() {
			return this.$parent.selected;
		},
		lang() {
			return this.$parent.lang;
		},
		showLegend() {
			return this.$parent.showLegend;
		}
	},
	watch: {
		selected(newval) {
			//console.log(this.$refs['marker.id'], newval);
			this.openPopup(newval);
			//this.recenterMap();
		}
	},
	methods: {
		getMarkerSize(size) {
			//console.log(size);
			return this.sizes[size];
		},
		getMarkerCoordinates(marker) {
			return [marker[1], marker[0]];
		},
		selectItem(id) {
			this.$emit('selected', { event: id, centermap: false });
		},
		openPopup() {
			let marker = this.$refs['marker.id'].find((lmarker) => lmarker.name == this.selected.event);
			//console.log(marker);
			marker.leafletObject.openPopup();
			if (this.selected.centermap) {
				this.$refs.Map.leafletObject.setView(marker.leafletObject.getLatLng(), 10);
			}
		},
		getDate(time) {
			const date = new Date(time);
			return timeAgo.format(date);
		},
		formatDate(time) {
			const date = new Date(time);
			let options = {
				day: 'numeric',
				month: 'short',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				hour12: false
			};
			return new Intl.DateTimeFormat('en-GB', options).format(date);
		},

		recenterMap() {
			this.$refs.Map.leafletObject.setView(this.center, 9);
			//console.log(this.center);
		}
	}
};
</script>
<style lang="scss">
.leaflet-map-pane svg {
	position: relative;
	left: -50%;
	top: 0;
}
.map_container {
	height: 710px !important;
	width: 100% !important;
	@media screen and (max-width: 992px) {
		height: 500px !important;
	}
}
.text-bold {
	font-weight: 600;
}
</style>
